var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BAAA3756-AA0E-42D0-93DB-76DB6E845111") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 59.9999 0 59.9999 60 0 60"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Help",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "General-Help-Page_V3",
    transform: "translate(-992.000000, -579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(960.000000, 547.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Question-mark",
    transform: "translate(32.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9999,0 C13.4314,0 -0.0001,13.4315 -0.0001,30 C-0.0001,46.5685 13.4314,60 29.9999,60 C46.5689,60 59.9999,46.5685 59.9999,30 C59.9999,13.4315 46.5689,0 29.9999,0 M29.9999,1.5 C45.7149,1.5 58.4999,14.285 58.4999,30 C58.4999,45.715 45.7149,58.5 29.9999,58.5 C14.2849,58.5 1.4999,45.715 1.4999,30 C1.4999,14.285 14.2849,1.5 29.9999,1.5",
    id: "Fill-1",
    fill: "#EDEBE9",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(22.000000, 13.000000)",
    stroke: "#05314D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.3329,8.15085 C0.3329,3.73235 4.0264,0.30085 8.5829,0.30085 C13.1389,0.30085 16.8329,3.88235 16.8329,8.30085 C16.8329,9.40535 16.6019,10.45735 16.1844,11.41485 C16.1844,11.41485 15.4994,13.88385 10.9994,17.88385 C10.9994,17.88385 7.3329,20.03435 7.3329,27.70085",
    id: "Stroke-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7826,33.40085 C9.7826,34.78135 8.6636,35.90085 7.2826,35.90085 C5.9021,35.90085 4.7826,34.78135 4.7826,33.40085 C4.7826,32.01985 5.9021,30.90085 7.2826,30.90085 C8.6636,30.90085 9.7826,32.01985 9.7826,33.40085 Z",
    id: "Stroke-6"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/Question-mark.6450866705456de9d1259ebe16c7a39f.svg";
export { ForwardRef as ReactComponent };